import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter, useHistory } from 'react-router-dom'
import { authActions } from '../../actions/authActions'
import { categoriesActions } from '../../actions/categoriesActions'
import { zonesActions } from '../../actions/zonesActions'
import { businessunitsActions } from '../../actions/businessunitsActions'
import { colorsActions } from '../../actions/colorsActions'
import { typesOfDocumentsActions } from '../../actions/typesOfDocumentsActions'
import { routes } from '../../constantes/routes'
import { tasksActions } from '../../actions/tasksActions'
import { eventsActions } from '../../actions/eventsActions'
import { phasesActions } from '../../actions/phasesActions'
import Eventos from '../../assests/img/eventos.svg'
import Presentaciones from '../../assests/img/presentaciones.svg'
import Catalogo from '../../assests/img/catalogo.svg'
import SeguimientoComercial from '../../assests/img/seguimiento.svg'
import Tareas from '../../assests/img/tareas.svg'
import Contactos from '../../assests/img/contactos.svg'
import Backoffice from '../../assests/img/backoffice.svg'
import './home.scss'

const Main = () => {
  const history = useHistory()

  const dispatch = useDispatch()
  const userProfile = useSelector((state) => state.userProfile)

  const getUserProfileAuth = () => dispatch(authActions.getUserProfileAuth())
  const getAllCategories = () => dispatch(categoriesActions.getAllCategories())
  const getAllTypesOfDocuments = () =>
    dispatch(typesOfDocumentsActions.getAllTypesOfDocuments())
  // const getAllTask = () => dispatch(tasksActions.getAllTasks(0));
  const getAllZones = () => dispatch(zonesActions.getZones())
  const getAllBusinessUnits = () =>
    dispatch(businessunitsActions.getAllBusinessUnits())
  const getAllColors = () => dispatch(colorsActions.getColors())
  const getAllEvents = () => dispatch(eventsActions.getAllEvents())
  const getAllPhases = () => dispatch(phasesActions.getAllPhases())

  useEffect(() => {
    getUserProfileAuth()
    getAllCategories()
    getAllTypesOfDocuments()
    // getAllTask();
    getAllZones()
    getAllBusinessUnits()
    getAllColors()
    getAllEvents()
    getAllPhases()
  }, [])

  const toBackoffice = () => {
    history.push(routes.BACKOFFICE)
  }

  const toContacts = () => {
    history.push(routes.CONTACTS)
  }

  const toPresentation = () => {
    history.push(routes.PRESENTATION)
  }

  const toManagement = () => {
    history.push(routes.MANAGEMENT)
  }

  const toCatalogueV2 = () => {
    history.push(routes.CATALOGUE_V2)
  }

  const toEventos = () => {
    history.push(routes.EVENTOS)
  }

  const toCrm = () => {
    history.push(routes.CRM)
  }

  return (
    <>
      <div className='main-wrap'>
        <div className='frameless-main'>
          {
            <button onClick={toEventos} className='btn big home-btn'>
              <img src={Eventos} alt='Eventos' />
              <p>Eventos</p>
            </button>
          }
          {
            <button onClick={toManagement} className='btn big home-btn'>
              <img src={Tareas} alt='Leads' />
              <p>Leads</p>
            </button>
          }
          {
            <button onClick={toCrm} className='btn big home-btn'>
              <img src={SeguimientoComercial} alt='Seguimiento Comercial' />
              <p>Seguimiento Comercial</p>
            </button>
          }
          {
            <button onClick={toPresentation} className='btn big home-btn'>
              <img src={Presentaciones} alt='Presentaciones' />
              <p>Presentaciones</p>
            </button>
          }
          {
            <button onClick={toCatalogueV2} className='btn big home-btn'>
              <img src={Catalogo} alt='Catálogo' />
              <p>Catálogo</p>
            </button>
          }
          {
            <button onClick={toContacts} className='btn big home-btn'>
              <img src={Contactos} alt='Contactos' />
              <p>Contactos</p>
            </button>
          }

          {/* {userProfile.roles.isEstadisticasVer ? (
            <button
              onClick={() => {
                alert('not implemented yet')
              }}
              className='btn big home-btn'
            >
              Estadísticas
            </button>
          ) : null} */}

          {userProfile.roles.isBackofficeVer ? (
            <button onClick={toBackoffice} className='btn big home-btn'>
              <img src={Backoffice} alt='Backoffice' />
              <p>Backoffice</p>
            </button>
          ) : null}
        </div>
      </div>
    </>
  )
}

export default withRouter(Main)
